import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
// import { propTypes } from 'react-bootstrap/esm/Image';
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../store/api/GetAllProduct";
import { ExclamationTriangleFill as Alert, Check, DashCircleFill as Cancel } from "react-bootstrap-icons";
import ProgressBar from '../../../Components/ProgressBar';
const ModalDialog = () => {
    const openDialog = useSelector(state => state.popup?.openDialog);
    const { arrayBtn, status, autoClose } = openDialog;
    const dispatch = useDispatch();
    const handleModal = () => {
        if (openDialog.okOperation !== undefined) {
            {
                dispatch(openDialog.okOperation);
            }
        }
        dispatch(setDialog({ status: 'hide' }));
    }

    useEffect(() => {
        if (autoClose) {
            setTimeout(() => {
                dispatch(setDialog({ status: 'hide' }));
            }, autoClose)
        }
    }, [status])
    return (
        <Modal show={openDialog.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle' style={{ display: 'inline-block', color: 'white', padding: '0.6rem 0.6rem', position:"relative" }}>
                <Alert size={22} style={{ color: 'rgb(255 178 4)' }} />&nbsp;&nbsp;{openDialog.dialogTitle}
                <ProgressBar duration={autoClose} height={5} style={{ position: "absolute", bottom: -2, right: 0 }} color="#bb1370" />
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <label className='scThin' style={{overflow:"auto", width:"100%", wordWrap:"break-word", maxHeight:"50vh"}}>{openDialog.dialogText}</label>
                {!autoClose &&

                    <>
                        <hr />
                        {arrayBtn && arrayBtn.includes("yes") && <Button className='group-Btn' variant='info' onClick={handleModal}><Check size={18} />بله</Button>}
                        {arrayBtn && arrayBtn.includes("no") && <Button className='group-Btn' variant='danger' onClick={() => dispatch(setDialog({ status: 'hide' }))}><Cancel size={18} /> &nbsp;خیر</Button>}
                        {arrayBtn && arrayBtn.includes("ok") && <Button className='group-Btn' onClick={() => handleModal()}>متوجه شدم</Button>}
                    </>
                }
            </Modal.Body>

        </Modal>
    )
}
export default ModalDialog;